import { ButtonBase, Box, type ButtonBaseProps } from '@mui/material'

interface IconBtnProps extends ButtonBaseProps {
  icon: string
}

const IconBtn: React.FC<IconBtnProps> = ({ icon, onClick }) => {
  return (
    <ButtonBase onClick={onClick}>
      <Box
        component="img"
        src={require(`../assets/images/${icon}`)}
        sx={{
          p: 1,
          borderRadius: '50%',
          background: '#F5F6F7',
          '&:hover': {
            background: '#EDEFF2'
          }
        }}
      />
    </ButtonBase>
  )
}

export default IconBtn
